import { FormControlLabel, Radio, RadioGroup } from "@material-ui/core";
import { CSSProperties, ChangeEvent } from "react";

interface RxRadioGroupProps {
	id?: string;
	ariaLabel?: string;
	name?: string;
	value: any;
	onChange?: (event: ChangeEvent<HTMLInputElement>, value: string) => void;
	row?: boolean;
	style?: CSSProperties;
	className?: string;
	radioButtons: RadioButtonsProps[];
}

export interface RadioButtonsProps {
	value: any;
	label: string;
	style?: CSSProperties;
	className?: string;
	disabled?: boolean;
	color?: "primary" | "secondary" | "default";
	size?: "small" | "medium";
}

const RxRadioGroup = (props: RxRadioGroupProps) => {
	return (
		<RadioGroup
			aria-label={props.ariaLabel}
			name={props.name}
			value={props.value}
			onChange={props.onChange}
			row={props.row}
			style={props.style}
			className={props.className}
		>
			{props.radioButtons.map((button, index) => (
				<FormControlLabel
					key={props.name + "_lb_" + index}
					value={button.value}
					label={button.label}
					disabled={button.disabled}
					control={
						<Radio
							style={button.style}
							className={button.className}
							color={button.color}
							size={button.size}
						/>
					}
				/>
			))}
		</RadioGroup>
	);
};

export default RxRadioGroup;
